import { FC } from 'react'

import { AttributeSection } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../../containers/EmbroideryService'
import { useEmbroideryForm } from '../../../../containers/EmbroideryService/useEmbroideryForm'
import { Variant } from '../../../../types/graphql'
import { IFormProps } from '../IFormProps'
import { EmbroideryOptionWrapper, FormBody } from '../shared-form-styles'
import { SubmissionButtons } from '../SubmissionButtons'

import { PortalEmbroideryLogo } from './PortalEmbroideryLogo'
import { useValidationSchema } from './useValidationSchema'

export const LogoEmbroideryForm: FC<IFormProps<Variant>> = ({ embroideryOption }) => {
  const { currentlySelectedFormOption } = EmbroideryService.useContainer()
  const validationSchema = useValidationSchema()
  const { form, resetForm } = useEmbroideryForm('LOGO_ONLY', {
    validationSchema,
    createEmbroideryOptions: values => ({
      logoName: values.logoName,
      logoImageSource: values.logoImageSource,
      logoPlacement: values.logoPlacement?.name,
      embroideryItemVariant: embroideryOption.variants[0],
    }),
  })

  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  return (
    <FormBody onSubmit={form.handleSubmit}>
      {form.values.logoImageSource && (
        <EmbroideryOptionWrapper>
          <AttributeSection title={fixtures.logoOption.logoLabel}>
            <PortalEmbroideryLogo
              src={form.values.logoImageSource}
              alt={`${form.values.logoName} Embroidery Logo`}
              widths={{ unit: 'px', sm: 180, md: 180 }}
            />
          </AttributeSection>
        </EmbroideryOptionWrapper>
      )}
      <EmbroideryOptionWrapper>
        <SubmissionButtons
          displayPrice={currentlySelectedFormOption?.variants[0]?.price}
          onReset={() => {
            resetForm()
          }}
        />
      </EmbroideryOptionWrapper>
    </FormBody>
  )
}
